import Captcha from './Captcha';

export default Captcha;
